import React, {Component} from "react";
import PropTypes from "prop-types";
import TextField from "material-ui/TextField";
import {FieldTitle} from "admin-on-rest";
import RaisedButton from 'material-ui/RaisedButton';
import {translate} from "admin-on-rest";

export class VoucherCodeInput extends Component {
  state = {
    value: this.props.input.value
  };

  componentDidMount() {
    this.setState({value: this.props.input.value});
  }

  handleBlur = eventOrValue => {
    this.props.onBlur(eventOrValue);
    this.props.input.onBlur(eventOrValue);
  };

  handleFocus = event => {
    this.props.onFocus(event);
    this.props.input.onFocus(event);
  };

  handleChange = eventOrValue => {
    eventOrValue.target.value = eventOrValue.target.value.toUpperCase();
    this.props.onChange(eventOrValue);
    this.props.input.onChange(eventOrValue);
  };

  generateCode = () => {
    let code = '';
    let letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789";

    for (let i = 0; i < 10; i++){
      code += letters.charAt(Math.floor(Math.random() * letters.length));
    }
    this.props.input.onChange(code);
  }

  render() {
    const {
      input,
      isRequired,
      label,
      meta,
      options,
      resource,
      source,
      type,
      style,
      translate
    } = this.props;

    // if (this.state.value) this.props.input.value = this.state.value;

    if (typeof meta === "undefined") {
      throw new Error(
        "The VoucherCodeInput component wasn't called within a redux-form <Field>. Did you decorate it and forget to add the addField prop to your component? See https://marmelab.com/admin-on-rest/Inputs.html#writing-your-own-input-component for details."
      );
    }
    const {touched, error} = meta;

    return (
      <React.Fragment>
        <TextField
          {...input}
          onChange={this.handleChange}
          type={type}
          floatingLabelText={
            <FieldTitle
              label={label}
              source={source}
              resource={resource}
              isRequired={isRequired}
            />
          }
          errorText={touched && error}
          style={style.voucherInput}
          value={input.value}
          {...options}
        />
        <RaisedButton
          primary
          label={translate('resources.promos.inputs.voucherCodeGenerate')}
          style={style.generateButton}
          onClick={this.generateCode}
        />
      </React.Fragment>
      
    );
  }
}

VoucherCodeInput.propTypes = {
  addField: PropTypes.bool.isRequired,
  elStyle: PropTypes.object,
  style: PropTypes.object,
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.object,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  options: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string,
  type: PropTypes.string,
  translate: PropTypes.func
};

VoucherCodeInput.defaultProps = {
  addField: true,
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  options: {},
  type: "text"
};

export default translate(VoucherCodeInput);



// WEBPACK FOOTER //
// ./src/components/VoucherCodeInputGenerate.js